var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zawa-room",on:{"wheel":_vm.onWheel}},[(_vm.selectedSpace && _vm.selectedRoom)?_c('Room',{attrs:{"data-service":_vm.dataService,"space":_vm.selectedSpace,"room":_vm.selectedRoom}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }